export const round = (value, precision) => {
  if (!value) {
    return null;
  }
  const multiplier = Math.pow(10, precision || 0);
  return Math.round(value * multiplier) / multiplier;
};
